import React from 'react';
import StorefrontLayout from './StorefrontLayout';
import CustomerAccountShell from './CustomerAccountShell';

type CustomerLayoutProps = {
  children: React.ReactNode;
};

/** Logged-in customer account / orders — storefront chrome + account sidebar layout. */
function CustomerLayout({ children }: CustomerLayoutProps) {
  return (
    <StorefrontLayout
      contentContained={false}
      mainFlushTop
      mainClassName="bg-transparent"
      footerAccountRailOffset
    >
      <CustomerAccountShell>{children}</CustomerAccountShell>
    </StorefrontLayout>
  );
}

export default CustomerLayout;
